var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.776.776A2.65 2.65 0 0 1 2.65 0H15.4c.22 0 .4.18.4.4v15a.4.4 0 0 1-.4.4H2.65A1.85 1.85 0 0 0 .8 17.65a.4.4 0 0 1-.8 0v-15C0 1.947.28 1.273.776.776ZM.8 15.753A2.65 2.65 0 0 1 2.65 15H15V.8H2.65A1.85 1.85 0 0 0 .8 2.65v13.103Z",
    fill: "url(#book_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.4 17.25c.22 0 .4.18.4.4V18h13.1a.4.4 0 0 1 0 .8H.4a.4.4 0 0 1-.4-.4v-.75c0-.22.18-.4.4-.4Z",
    fill: "url(#book_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "book_svg__a",
    x1: 1.64,
    y1: 3.223,
    x2: 12.909,
    y2: 3.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8567"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "book_svg__b",
    x1: 1.484,
    y1: 17.527,
    x2: 11.42,
    y2: 19.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8567"
  })))));
};
export default SvgBook;